import { useEffect, useState } from "react";
import { CONTACT } from "../../content/site";

const DAYS = { Mon: 1, Tue: 2, Wed: 3, Thu: 4, Fri: 5, Sat: 6, Sun: 7 };
const fmt = new Intl.DateTimeFormat("en-US", { timeZone: "Europe/Berlin", weekday: "short", hour: "numeric", minute: "numeric", hourCycle: "h23" });

const isOpen = () => {
  const parts = Object.fromEntries(fmt.formatToParts(new Date()).map((p) => [p.type, p.value]));
  const slot = CONTACT.schedule[DAYS[parts.weekday]];
  if (!slot) return false;
  const h = Number(parts.hour) + Number(parts.minute) / 60;
  return h >= slot[0] && h < slot[1];
};

export const AvailableBadge = () => {
  const [open, setOpen] = useState(isOpen);
  useEffect(() => {
    const t = setInterval(() => setOpen(isOpen()), 60000);
    return () => clearInterval(t);
  }, []);
  if (!open) return null;
  return (
    <span data-testid="available-now-badge" className="mt-3 inline-flex items-center gap-2 rounded-full bg-[#FBF9F4]/10 px-3 py-1 text-sm text-[#DCEFBE]">
      <span className="relative flex h-2.5 w-2.5">
        <span className="absolute inline-flex h-full w-full animate-ping rounded-full bg-[#7CE08A] opacity-60 motion-reduce:animate-none" />
        <span className="relative inline-flex h-2.5 w-2.5 rounded-full bg-[#7CE08A]" />
      </span>
      Gerade erreichbar
    </span>
  );
};
